declare global {
  interface Window {
    __NEXO_CONFIG__?: {
      environment?: 'development' | 'staging' | 'production';
      releaseVersion?: string;
      siteUrl?: string;
      supabaseUrl?: string;
      supabaseAnonKey?: string;
      authMode?: 'auto' | 'local' | 'supabase';
      cloudSyncMode?: 'auto' | 'local' | 'supabase';
      billingProvider?: 'manual' | 'mercado-pago';
      openAiEnabled?: boolean;
      tapassEnabled?: boolean;
      sentryDsn?: string;
    };
  }
}
const browserConfig = typeof window === 'undefined' ? undefined : window.__NEXO_CONFIG__;
const supabaseUrl = browserConfig?.supabaseUrl?.trim() ?? '';
const supabaseAnonKey = browserConfig?.supabaseAnonKey?.trim() ?? '';
export const runtimeConfig = {
  environment: browserConfig?.environment ?? 'development',
  releaseVersion: browserConfig?.releaseVersion ?? 'nexo-local',
  siteUrl: browserConfig?.siteUrl?.trim() || (typeof window === 'undefined' ? '' : window.location.origin),
  supabaseUrl,
  supabaseAnonKey,
  functionsUrl: supabaseUrl ? `${supabaseUrl.replace(/\/$/, '')}/functions/v1` : '',
  authMode: browserConfig?.authMode ?? 'auto',
  cloudSyncMode: browserConfig?.cloudSyncMode ?? 'auto',
  billingProvider: browserConfig?.billingProvider ?? 'manual',
  openAiEnabled: browserConfig?.openAiEnabled ?? false,
  tapassEnabled: browserConfig?.tapassEnabled ?? false,
  sentryDsn: browserConfig?.sentryDsn?.trim() ?? '',
} as const;
export const isSupabaseConfigured = Boolean(runtimeConfig.supabaseUrl && runtimeConfig.supabaseAnonKey);
export const resolvedAuthMode = runtimeConfig.authMode === 'supabase' ? 'supabase' : runtimeConfig.authMode === 'local' ? 'local' : isSupabaseConfigured ? 'supabase' : 'local';
export const resolvedCloudSyncMode = runtimeConfig.cloudSyncMode === 'supabase' ? 'supabase' : runtimeConfig.cloudSyncMode === 'local' ? 'local' : isSupabaseConfigured ? 'supabase' : 'local';
export const isProductionRuntime = runtimeConfig.environment === 'production';
